export default __webpack_public_path__ + "static/media/EM0360.34I-23431_-15270_0.cd1cf55e.jpg";